import { RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';

const HotelStaffComponent = lazy(() => import('./hotel-staff.tsx'));

export const hotelStaffRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <Suspense>
        <HotelStaffComponent />
      </Suspense>
    )
  }
];
